import { useState, useEffect } from "react";
import { countdown } from "@/lib/format";

export const FlashTimer = ({ endsAt, label, className = "" }) => {
  const [t, setT] = useState(() => countdown(endsAt));
  useEffect(() => {
    const id = setInterval(() => setT(countdown(endsAt)), 1000);
    return () => clearInterval(id);
  }, [endsAt]);
  return (
    <span data-testid="flash-deal-countdown" className={`flex items-center gap-1.5 text-xs font-semibold ${className}`}>
      {label && <span className="opacity-80">{label}</span>}
      <span className="font-mono tabular-nums">{t}</span>
    </span>
  );
};
